module.exports = __webpack_public_path__ + "img/a_4.b140fd22.png";